import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import AppUserAvatar from '../../../../components/designe/app-entity-avatar/app-user-avatar/AppUserAvatar';
import AppFile from '../../../../components/designe/app-file/AppFile';
import { useGetMyDetails } from '../../../../redux/api/users/usersApi';
import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { IBugReportMessage } from '../../../../types/interfaces/bug-report-message';
import { useStyles } from './BugReportMessage.styles';

interface IBugReportMessageProps {
  message: IBugReportMessage;
}

export default function BugReportMessage(props: IBugReportMessageProps) {
  const { data: user } = useGetMyDetails();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { message } = props;
  const isNotMyMessage = user?.id !== message.userId;

  return (
    <Box
      className={clsx(
        classes.messageWrapper,
        isNotMyMessage && classes.notMyMessage,
      )}>
      <AppUserAvatar
        entity={message.user}
        size={AvatarSize.s}
        type={AvatarTypes.round}
      />
      <Box className={classes.messageContainer}>
        <Box className={classes.filesContainer}>
          {!!message?.files?.length &&
            message?.files.map((file) => <AppFile key={file.id} file={file} />)}
        </Box>
        <Typography
          variant="text-md"
          style={{ wordBreak: 'normal', whiteSpace: 'pre-wrap' }}>
          {message.message}
        </Typography>
      </Box>
    </Box>
  );
}
